export default "__VITE_ASSET__DXKNk6wM__"